import React, { useState } from 'react';
import { FaLongArrowAltUp, FaLongArrowAltDown } from 'react-icons/fa';

//components
import MiscFeesCard from './MiscFeesCard';

//hooks
import { useSortAndReverse } from '../../../../../shared/hooks/useSortAndReverse';

//styles
import {
  ListPlaceholderStyles,
  TableStyles,
  TableHeaderStyles,
  TableItemStyles,
} from '../../../../../SharedStyles';

//helpers
import { miscHeaderFees } from '../helpers';

const MiscFeesList = (props) => {
  const { strings, statementDetails } = props;
  const [sessions, setSessions] = useState([]);

  const updateSortedItems = (items) => {
    setSessions(items);
  };

  /**
   * Can be two of these per page for enterprise and non-enterprise
   * @param {*} sortStatus - status for the default sort
   * @param {*} dataArray - items that will be sorted
   * @param {*} headerText - strings array that will show user friendly name to map over
   * @param {*} headerConvert - converts strings in headerText array to object notation, custom function needed for this logic
   * @param {*} updateSortedItem - Function to update the current state with the sorted items
   */
  const [isActiveSort, sortReverse, changeActiveSort] = useSortAndReverse(
    'date',
    statementDetails.statementMiscFeeLineItems,
    strings.miscFeesHeader,
    miscHeaderFees,
    updateSortedItems,
    'desc'
  );

  return (
    <TableStyles
      maxHeight='340px'
      minHeight={sessions.length ? sessions.length * 35 : '200px'}
      overflowX='hidden'
      width='100%'>
      <TableHeaderStyles
        borderTop='none'
        borderLeft='none'
        borderRight='none'
        width='761px'>
        {strings.miscFeesHeader.map((title, i) => {
          return (
            <TableItemStyles
              width='100%'
              maxWidth={title === 'Ports' ? '75px' : 'auto'}
              borderRight
              key={i}
              onClick={() => {
                changeActiveSort(miscHeaderFees[title]);
              }}>
              {isActiveSort[miscHeaderFees[title]] && (
                <div>
                  {sortReverse[miscHeaderFees[title]] ? (
                    <FaLongArrowAltDown />
                  ) : (
                    <FaLongArrowAltUp />
                  )}{' '}
                </div>
              )}
              {title}
            </TableItemStyles>
          );
        })}
      </TableHeaderStyles>
      {sessions.map((item, i) => (
        <MiscFeesCard
          key={i}
          date={item.date}
          description={item.description}
          amount={item.amount}
        />
      ))}
      {sessions.length === 0 && (
        <ListPlaceholderStyles borderBottom='none'>
          <p>{strings.noFees}</p>
        </ListPlaceholderStyles>
      )}
    </TableStyles>
  );
};

export default MiscFeesList;
